import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { useMediaQuery } from 'react-responsive';
import { Row, Col, Typography, Icon, Divider } from 'antd';
import { Link } from 'react-router-dom';
import ExternalLink from '../ExternalLink';
import CheckatradeLogo from '../../assets/images/checkatrade-verified.png';
import { CONTACT_PHONE, OFFICE_PHONE, CONTACT_EMAIL } from '../../constants';
import theme from "../../theme";


const { Text, Paragraph } = Typography;

const LINKS = [
    {
        label: 'FAQs',
        url: '/faqs',
    },
    {
        label: 'Terms & Conditions',
        url: '/terms-and-conditions',
    },
    {
        label: 'Privacy Policy',
        url: '/privacy-policy',
    },
    {
        label: 'Members Area',
        url: '/login'
    },
];

const StyledFooter = styled.footer`
    background: ${props => props.theme.palette.black};
    padding: ${props => props.theme.unit * 10}px ${props => props.theme.unit * 10}px;
    
    & .contact-info {
        display: block;
        color: white;
        margin-bottom: 1em;
    }
    
    & .contact-details a {
        color: white;
    }
    
    @media (max-width: ${props => props.theme.breakpoint.sm}px) {
        padding: ${props => props.theme.unit * 5}px ${props => props.theme.unit * 2}px;
        
        img {
            margin-top: ${props => props.theme.unit * 2}px;
        }
    }
`;

const StyledLinks = styled.ul`
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0 0 ${props => props.theme.unit * 2}px;
    
    & li {
        margin-right: ${props => props.theme.unit * 2}px;
    }
    
    @media (max-width: ${props => props.theme.breakpoint.sm}px) {
        flex-direction: column;
        
        & li {
            margin-right: 0;
            margin-bottom: ${props => props.theme.unit * 2}px;
        }
    }
`;

const Footer = () => {
    const isSmDown = useMediaQuery({
        maxWidth: theme.breakpoint.sm,
    });

    return (
        <StyledFooter>
            <Row spacing={40} type="flex" justify="space-between">
                {
                    isSmDown
                    ? <Col>
                        <Paragraph className="contact-info">
                            <Icon type="phone" theme="filled" />&nbsp;
                            Mobile: { CONTACT_PHONE }
                        </Paragraph>
                        <Paragraph className="contact-info">
                            <Icon type="phone" theme="filled" />&nbsp;
                            Office: { OFFICE_PHONE }
                        </Paragraph>
                        <Paragraph style={{ color: 'white' }}>
                            <Icon type="mail" theme="filled" />&nbsp;
                            Email: { CONTACT_EMAIL }
                        </Paragraph>
                    </Col>
                    :  <Col className="contact-details">
                        <Text className="contact-info">
                            <Icon type="phone" theme="filled" />&nbsp;
                            Mobile: <a href={`tel: ${ CONTACT_PHONE }`}>{ CONTACT_PHONE }</a> | Office: <a href={`tel: ${ OFFICE_PHONE }`}>{ OFFICE_PHONE }</a>
                        </Text>
                        <Text style={{ display: 'block', color: 'white' }}>
                            <Icon type="mail" theme="filled" />&nbsp;
                            <a href={`mailto: ${ CONTACT_EMAIL }`}>{ CONTACT_EMAIL }</a>
                        </Text>
                    </Col>
                }
                <Col>
                    <ExternalLink
                        urlKey="CHECKATRADE_PROFILE"
                        style={{ width: 220, display: 'block' }}
                    >
                        <img src={CheckatradeLogo} alt="Proud members of Checkatrade" style={{ width: '100%' }} />
                    </ExternalLink>
                </Col>
            </Row>
            <Divider />
            <Row spacing={40} type="flex" justify="space-between">
                <Col span={ isSmDown ? 24 : null }>
                    <StyledLinks>
                        {
                            LINKS.map(link =>
                                <li key={link.url}>
                                    <Link to={link.url} key={link.url}>
                                        { link.label }
                                    </Link>
                                </li>
                            )
                        }
                    </StyledLinks>
                </Col>
                <Col>
                    <Text style={{ color: 'white' }}>
                        { moment().format('Y') } © Clear H2O Window Cleaning Ltd
                    </Text>
                </Col>
            </Row>
        </StyledFooter>
    );
};

export default Footer;
